import { useDeviceType } from '@/hooks/useDeviceType';

export default function ResponsiveLayout({ mobile, desktop }) {
  const { isMobile } = useDeviceType();
  return isMobile ? mobile : desktop;
}

